import { ca } from '@cian/analytics';
import { EAdvantageType } from '../../types/newbuilding/advantages';

export function trackAdvantagesItemClick(label: EAdvantageType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_features_jk',
    label,
  });
}
